module.exports = __webpack_public_path__ + "static/media/injection-syringe.b6051659.svg";